module.exports = __webpack_public_path__ + "img/menu_btn.188dbd70.svg";